<template>
  <v-container fluid class="expensereport-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" sm="12" md="12" lg="12" class="d-flex flex-start justify-md-start overflow-auto">
              <v-btn 
                color="success" 
                class="button-shadow mr-3"
                @click="isFindDialog = true"
              >
                <v-icon class="mr-2">mdi-account-search</v-icon>
                Find
              </v-btn>
              <download-excel
                class="btn btn-default"
                :data="getJson()"
                worksheet="My Worksheet"
                type="xls"
                :name="getFileName()"
              >
              <v-btn 
                v-show="expensereports.length>0"
                color="default" 
                class="button-shadow mb-2 mr-0 mr-sm-2"
              >
                <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
                Save
              </v-btn>
              </download-excel>
              <v-btn to="/bill/list" color="default" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-file-multiple</v-icon>
                Bills
              </v-btn>
              <v-btn to="/expensereport/bylocation" color="default" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-file-multiple</v-icon>
                By Location
              </v-btn>
              <v-btn to="/expensereport/bychannel" color="default" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-file-multiple</v-icon>
                By Channel
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="expensereports-table"
              single-select
              item-key="_id"
              sort-by="expensereportname"
              :footer-props="footer"
              :headers="headers"
              :items="expensereports"
              :items-per-page="itemPerPage">
              <template v-slot:item.startdate="{ item }">
                {{ item.startdate!=null ? new Date(item.startdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '' }}
              </template>
              <template v-slot:item.enddate="{ item }">
                {{ item.enddate!=null ? new Date(item.enddate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric'  }) : '' }}
              </template>
              <template v-slot:item.accountsubclass="{ item }">
                <p class="two-line">{{ item.accountsubclass }}</p>
              </template>
              <template v-slot:item.amount="{ item }">
                {{ item.amount!==undefined ? (item.amount).toFixed(2) : '' }}
              </template>
              <template v-slot:item.avgprice="{ item }">
                {{ item.avgprice!==undefined ? (item.avgprice).toFixed(1) : '' }}
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
    <v-dialog
      v-model="isFindDialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Find Expense Report</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                        <v-menu
                          ref="menu_startdate"
                          v-model="menu_startdate"
                          :close-on-content-click="false"
                          :return-value.sync="find_query.startdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="find_query.startdate"
                              label="Start Date"
                              v-bind="attrs"
                              v-bind:value="find_query.startdate"
                              v-on="on"
                              persistent-hint
                              single-line hint="Please enter start date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="find_query.startdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_startdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_startdate.save(find_query.startdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                        <v-menu
                          ref="menu_enddate"
                          v-model="menu_enddate"
                          :close-on-content-click="false"
                          :return-value.sync="find_query.enddate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="find_query.enddate"
                              label="End Date"
                              v-bind="attrs"
                              v-bind:value="find_query.enddate"
                              v-on="on"
                              persistent-hint
                              single-line hint="Please enter end date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="find_query.enddate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_enddate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_enddate.save(find_query.enddate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="find_query = {}"
          >
            Clear
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="isFindDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="findExpenseReport"
          >
            Find
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'ExpenseReportByAccount',
  data() {
    return {
      headers: [
        { text: 'Start', value: 'startdate' },
        { text: 'End', value: 'enddate' },
        { text: 'Class', value: 'accountsubclass' },
        { text: 'Account', value: 'accountname' },
        { text: 'Amount', value: 'amount' },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 500,
      isFindDialog: false,
      find_query: {},
      expensereports: [],
      menu_startdate: null,
      menu_enddate: null,
    }
  },
  computed: {
    ...mapState('ExpenseReport', ['isDeleting', 'isReceiving']),
  },
  methods: {
    ...mapActions('ExpenseReport', ["getExpenseReportByAccountRequest", "findExpenseReportByAccountRequest"]),
    async findExpenseReport(){
      this.isFindDialog = false;
      let result = await this.findExpenseReportByAccountRequest(this.find_query);
      this.expensereports = result;
      this.expensereports.push({accountname: 'Total', amount: this.expensereports.reduce(function (last, json) {return last + json.amount;}, 0) });
    },
    getJson(){
      let json = this.expensereports.map(item=>{return {
        start_date: item.startdate!=null ? new Date(item.startdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '',
        end_date: item.enddate!=null ? new Date(item.enddate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '',
        account_class: item.accountclass,
        account_subclass: item.accountsubclass,
        account_name: item.accountname,
        amount: item.amount
      }});
      return json;
    },
    getFileName(){
      var d = new Date();
      var name = 'expense-report-' + d.getFullYear() + '-' + (d.getMonth()+1).toString() + '-' + d.getDate() + '-' + (d.getHours().toString() +d.getSeconds().toString());
      return name + '.xls';
    },
  },
  async created () {
    let result = await this.getExpenseReportByAccountRequest();
    this.expensereports = result;
    this.expensereports.push({accountname: 'Total', amount: this.expensereports.reduce(function (last, json) {return last + json.amount;}, 0) });
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
